import './enhanced-text-area.scss'

import { faEraser } from '@fortawesome/free-solid-svg-icons';
import { FormApi } from 'final-form';
import { set } from 'lodash'
import Component from 'vue-class-component';

import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Watch } from 'vue-property-decorator';

@Component({
    props: ['placeHolder', 'scanEnabled', 'defaultValue', 'form', 'name', 'autoUpdate'],
    template: require('./enhanced-text-area.html'),
})
export class EnhancedTextArea<T> extends ReactiveVue {

    public clearIcon = faEraser;
    public placeHolder: string;

    public value: string = "";
    public defaultValue: string;

    public form: FormApi;
    public name: string;
    public autoUpdate: boolean;

    public eraseInput() {
        this.setFieldValue("");
    }

    public mounted() {
        this.setFieldValue(this.defaultValue);
        this.$on('field-value-changed', (message) =>
            this.$parent.$emit('field-value-changed', message)
        )
    }

    private setFieldValue(value: string) {
        set(this.form.getState().values, this.name, value)
        this.form.mutators.setFieldTouched(this.name);
    }
}